<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <div class="flex items-center justify-between gap-4 mb-4">
                <p class="text-lg font-medium">{{ branch.title }} Resources</p>
            </div>

            <breeze-table
                :fields="fields"
                :items="submissions"
                :canView="true"
            >
                <template #resource="data">
                    <div class="font-medium">{{ data.item.resource.title }}</div>
                    <div class="max-w-xl text-gray-500 whitespace-normal" v-if="data.item.resource.description">
                        {{ data.item.resource.description }}
                    </div>
                </template>
                <template #due_date="data">
                    {{ formatDate(data.item.resource.due_date) }}
                </template>
                <template #status="data">
                    {{ statusLabel(data.item.status) }}
                    <div class="mt-1 text-xs text-red-600 whitespace-normal" v-if="data.item.decline_reason">
                        {{ data.item.decline_reason }}
                    </div>
                </template>
                <template #file="data">
                    <a v-if="data.item.file_url" :href="data.item.file_url" target="_blank" class="text-indigo-600 hover:text-indigo-900">
                        {{ data.item.file_name }}
                    </a>
                    <span v-else>Not uploaded</span>
                </template>
                <template #upload="data">
                    <div class="flex flex-col gap-2 min-w-[320px]" v-if="data.item.status !== 'accepted'">
                        <div class="flex items-center gap-2">
                            <input type="file" class="block w-52 text-sm text-gray-700" @change="selectFile($event, data.item)" />
                            <breeze-button type="button" :disabled="uploadForm.processing || selectedSubmissionId !== data.item.id || !uploadForm.file" @click="upload(data.item)">
                                {{ data.item.status === 'declined' ? 'Reupload' : 'Upload' }}
                            </breeze-button>
                        </div>
                        <breeze-input-error :message="uploadForm.errors?uploadForm.errors.file:''" v-if="selectedSubmissionId === data.item.id" />
                    </div>
                    <span v-else>-</span>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import BreezeTable from '@/Components/Table'
import {useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Internal,
        BreezeButton,
        BreezeInputError,
        BreezeTable,
    },
    props: ['branch', 'submissions'],
    data() {
        return {
            selectedSubmissionId: null,
            uploadForm: useForm({
                file: null,
            }),
            fields: [
                {'key': 'resource', 'label': 'Resource'},
                {'key': 'due_date', 'label': 'Due Date'},
                {'key': 'status', 'label': 'Status'},
                {'key': 'file', 'label': 'File'},
                {'key': 'upload', 'label': 'Upload'},
            ],
        }
    },
    methods: {
        formatDate(date) {
            return date ? date.substring(0, 10) : '-';
        },
        statusLabel(status) {
            return status.replace('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
        },
        selectFile(event, submission) {
            this.selectedSubmissionId = submission.id;
            this.uploadForm.file = event.target.files[0];
        },
        upload(submission) {
            this.uploadForm.post(route('internal.resource.upload', [this.branch.id, submission.id]), {
                preserveScroll: true,
                forceFormData: true,
                onSuccess: () => {
                    this.selectedSubmissionId = null;
                    this.uploadForm.reset();
                },
            });
        },
    },
}
</script>
